import { Alert } from 'antd';
import styled from 'styled-components';
import Center from './Center';

const StyledAlert = styled(Alert)`
	margin-top: 5em;
	min-width: 300px;
`;

const ErrorComponent: React.FC = () => (
	<Center>
		<StyledAlert
			message="Jejda, něco se pokazilo"
			description="Je nám líto, ale něco se nepovedlo. Zkuste to prosím znovu za chvilku."
			type="error"
			showIcon
		/>
	</Center>
);

export default ErrorComponent;
